module.exports = __webpack_public_path__ + "static/media/R-280HD_CrossSection.1379b2a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/chambers/en/R-280HD_CrossSection.png
// module id = 477
// module chunks = 0